import { createContext } from 'react';
import { Modules } from '~/lib/data-contract';

export type ModuleContextType<T = Modules> = {
    index: number;
    element: T | Record<string, string>;
};

export const ModuleContext = createContext({ index: 0, element: {} });
